import { LocalizedText } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { Banner, Typography } from '@optimus-web/core';

export const TwoFactorAuthWarningBanner = () => (
    <Banner
        variant="warning"
        primaryText={
            <Typography textStyle="bodyMediumStrong" as="div">
                <LocalizedText textKey={TextKey.PlatformProfileTwoFactorAuthenticationDeactivatedTitle} />
            </Typography>
        }
        secondaryText={<LocalizedText textKey={TextKey.PlatformProfileTwoFactorAuthenticationDeactivatedDescription} />}
    />
);
